export default {
    title: 'Care',
    every: 'every {n} mo.',
    everyKm: 'every {km} km',
    everyOr: '{months} or {km} km',
    once: 'one-off',
    everyLabel: 'How often',
    everyKmLabel: 'Every how many km (optional)',
    km: {
        left: '~{km} km left',
        over: '{km} km past due',
        at: 'at {km} km',
        noData: 'the date by km will be counted from odometer readings',
    },
    name: 'Care name',
    last: 'last {date}',
    never: 'not done yet',
    next: 'Next {when} · {date}',
    manual: 'set by hand',
    noTerm: 'no date',
    noTermYet: 'date after the first “Done”',
    setDue: 'Change date',
    fromLog: 'Count from last done',
    done: 'Done',
    edit: 'Edit care “{name}”',
    remove: 'Delete care “{name}”',
    removed: 'Deleted care “{name}”',
    undo: 'Undo',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    history: 'History ({n})',
    editLog: 'Edit entry',
    removeLog: 'Delete entry',
    removeLogAsk: 'This entry has an expense in Wallet. Delete the expense too?',
    removeLogWithExpense: 'Delete with expense',
    removeLogOnly: 'Entry only',
    inWallet: 'in Wallet',
    logDocuments: 'Entry documents: {n}',
    add: 'Add care',
    addSave: 'Add',
    suggestionsTitle: 'Suggestions',
    customPlaceholder: 'Your own name, e.g. Filter change',
    empty: {
        pet: 'Vaccination, deworming, ticks — add what needs doing regularly and the date will show up in “Right now” and in the Planner.',
        device: 'Service, filter change, descaling — add what needs doing regularly and the date will show up in “Right now” and in the Planner.',
    },
    form: {
        date: 'Day',
        cost: 'Cost',
        note: 'Note (optional)',
        km: 'Odometer (km)',
        addExpense: 'Add to Wallet as an expense',
        saveDone: 'Save',
    },
    documents: {
        title: 'Documents',
        empty: 'Vaccination record, warranty card, service invoice — a photo or a PDF.',
        camera: 'Take a photo',
        file: 'Add a file',
        uploading: 'Uploading…',
        open: 'Open “{name}”',
        rename: 'Change title',
        titlePlaceholder: 'Title, e.g. Vaccination record',
        remove: 'Delete document “{name}”',
        removed: 'Deleted document “{name}”',
        fromLog: '{care} · {date}',
        addFailed: 'Could not add the file.',
        tooLarge: 'The file is too large (max 20 MB).',
        unsupported: 'Photos (JPG, PNG, WebP) and PDF are allowed.',
        openFailed: 'Could not open the file.',
    },
    when: {
        today: 'today',
        tomorrow: 'tomorrow',
        inDays: 'in {n} day | in {n} days',
        late: '{n} day overdue | {n} days overdue',
    },
    badge: '{when} · {what}',
    planner: '{icon} {subject}: {name}',
    suggestions: {
        vaccine: 'Vaccination',
        deworming: 'Deworming',
        ticks: 'Ticks and fleas',
        vet: 'Vet check-up',
        grooming: 'Grooming',
        claws: 'Claws',
        inspection: 'Roadworthiness test',
        insurance: 'Car insurance',
        oil: 'Oil change',
        timing: 'Timing belt',
        tyres: 'Winter/summer tyres',
        descaling: 'Descaling',
        filter: 'Filter',
        service: 'Service',
    },
};
